import React, { useState } from 'react';
import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import TableCellComponent from '../table-cell';
import { useStyles } from './style';
import { ConfirmationDialog } from '../confrimDialog';
import parse from 'html-react-parser';

const getColumnSx = (column, compact) => ({
  ...(column.width && { width: column.width }),
  ...(column.maxWidth && { maxWidth: column.maxWidth }),
  ...(compact && { fontSize: '0.8125rem', py: 0.75, px: 1 }),
});

export function TableRows({
  rows,
  uniqueKey,
  tableCells,
  actionsIcons,
  handleActionClick,
  handleContentClick,
  compact = false,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleConfirm = () => {
    handleActionClick(0, selectedRow);
    setOpen(false);
  };

  const cleanToPlainText = (html) => {
    return html
      .replace(/<[^>]+>/g, '')        // Remove HTML tags
      .replace(/&nbsp;/gi, ' ')       // Replace &nbsp; with space
      .replace(/\s+/g, ' ')           // Collapse multiple spaces/newlines
      .trim();                        // Trim ends
  };

  const getDirection = (text) => {
    const firstChar = text.trim().charAt(0);
    return /[\u0600-\u06FF]/.test(firstChar) ? 'rtl' : 'ltr'; // Urdu/Arabic Unicode range
  };

  return (
    <>
      {rows &&
        Object.keys(rows).length > 0 &&
        rows?.map(row => (
          <TableRow
            key={row.id + `${uniqueKey ? uniqueKey : '-key'}`}
            sx={compact ? { '& td': { py: 0.75, px: 1 } } : undefined}
          >
            {tableCells &&
              Object.keys(tableCells).length > 0 &&
              tableCells.map(
                t => {
                  let cellValue = row[t.id];
                  if (t.id === 'bookId' && cellValue) {
                    cellValue = row?.Book?.bookName || cellValue;
                  }
                  if (t.id === 'chapterId' && cellValue) {
                    cellValue = row?.Chapter?.chapterName || cellValue;
                  }
                  if (t.id === 'languageId' && cellValue) {
                    cellValue = row?.Language?.name || cellValue;
                  }

                  return (
                    (t.id !== 'actions') && (
                      <TableCellComponent
                        tableId={t.id}
                        key={t.id}
                        compact={compact}
                        rowData={row}
                        sx={getColumnSx(t, compact)}
                        cellData={
                          t.id === 'content' && handleContentClick ? (
                            <Typography
                              onClick={() => handleContentClick(cellValue, row)}
                              sx={{
                                fontFamily: "'Jameel Noori Nastaleeq', serif",
                                cursor: 'pointer',
                                direction: getDirection(cleanToPlainText(cellValue)),
                                textAlign: getDirection(cleanToPlainText(cellValue)) === 'rtl' ? 'right' : 'left',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 400,
                                fontSize: '14px',
                                color: 'primary.main',
                              }}
                              title="Click to read full content"
                            >
                              {cellValue ? cleanToPlainText(cellValue) : cellValue}
                            </Typography>
                          ) : (
                            cellValue
                          )
                        }
                      />
                    )
                  )
                })}
            {actionsIcons && Object.keys(actionsIcons).length > 0 && (
              <TableCell align='left' sx={compact ? { py: 0.5, px: 1 } : undefined}>
                <Box className={classes.actionBox} component='div'>
                  {actionsIcons.map((item, index) =>
                    item.allowedWhen &&
                      row[item.allowedWhen] &&
                      Object.keys(row[item.allowedWhen]).length > 0 ? (
                      <IconButton
                        onClick={() => {
                          if (item.action === 'delete') {
                            setSelectedRow(row);
                            setOpen(true);
                          } else {
                            handleActionClick(index, row);
                          }
                        }}
                        className={classes.iconBox}
                        key={index + 'icons'}
                      >
                        {item.icon}
                      </IconButton>
                    ) : (
                      !item.allowedWhen && (
                        <IconButton
                          onClick={() => {
                            if (item.action === 'delete') {
                              setSelectedRow(row);
                              setOpen(true);
                            } else {
                              handleActionClick(index, row);
                            }
                          }}
                          className={classes.iconBox}
                          key={index + 'icons'}
                        >
                          {item.icon}
                        </IconButton>
                      )
                    )
                  )}
                </Box>
              </TableCell>
            )}
          </TableRow>
        ))}
      <ConfirmationDialog
        open={open}
        handleClose={handleClose}
        handleOk={handleConfirm}
        title="Are you sure.?"
        message="You want to delete this record"
        buttonTitle={"Yes"}
      />
    </>
  );
};

